/* eslint-disable */

import React, { useEffect, useState } from 'react';
import { getStorage } from '../../utils/functions/localstorage';
import api from '../../utils/functions/api';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Switch,
  Typography,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';

function Setting() {
  const [enabled, setEnabled] = useState(false);
  const [expiredToken, setExpiredToken] = useState(false);
  const [valueExpiredToken, setValueExpiredToken] = useState('');
  const [openDialog, setOpenDialog] = useState(false);

  const bounceEnd = keyframes`
  0%   { transform: scale(1); }
  60%  { transform: scale(1.12); }
  80%  { transform: scale(0.96); }
  100% { transform: scale(1); }
`;

  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 52,
    height: 32,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transition: 'transform 0.45s cubic-bezier(0.22, 1, 0.36, 1)',
      '&.Mui-checked': {
        transform: 'translateX(20px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#007CC2', // ✅ สีเข้มเวลาเปิด
          opacity: 1,
        },
        '& .MuiSwitch-thumb': {
          backgroundColor: '#fff', // ✅ สีของปุ่ม
          animation: `${bounceEnd} 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)`,
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 28,
      height: 28,
      backgroundColor: '#fff',
      borderRadius: '50%',
      boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
    },
    '& .MuiSwitch-track': {
      borderRadius: 16,
      backgroundColor: '#E5E5EA',
      opacity: 1,
      transition: 'background-color 0.45s ease-in-out',
    },
  }));

  const handleToggle = (event) => {
    const newValue = event.target.checked;
    setEnabled(newValue);
    changeSettings(newValue);
  };

  const getSettings = async () => {
    try {
      const token = getStorage('token');

      const { data } = await api.get(
        `${process.env.REACT_APP_APIHOST}/policy`,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      console.log('Settings fetched successfully:', data);

      setEnabled(data.data[0].is_active);
      //   console.log('setEnabled', enabled);
      if (!data) {
        throw new Error('Network response was not ok');
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  useEffect(() => {
    getSettings();
  }, []);

  const getExpiredToken = async () => {
    try {
      const token = getStorage('token');
      const { data } = await api.get(
        `${process.env.REACT_APP_APIHOST}/configs`,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      setExpiredToken(data.data[0]);
      console.log('expiredToken', expiredToken);
    } catch (error) {
      console.log('error', error);
    }
    // Logic to handle expired token, e.g., redirect to login
  };

  useEffect(() => {
    getExpiredToken();
  }, []);

  const changeSettings = async (value) => {
    try {
      const token = getStorage('token');
      console.log('enabled', enabled);
      const { data } = await api.put(
        `${process.env.REACT_APP_APIHOST}/policy/1`,
        {
          policy_type: 'payment_policy',
          is_active: value, // สมมติว่า enabled เป็น boolean ค่าที่จะส่ง
        },
        {
          headers: {
            Authorization: token,
          },
        },
      );
      if (!data) {
        throw new Error('Network response was not ok');
      }
      console.log('Settings updated successfully:', data);
    } catch (error) {
      console.error('Error updating settings:', error);
    }
  };

  const changeExpiredToken = async () => {
    try {
      const token = getStorage('token');
      console.log('value', expiredToken);
      console.log('expiredToken', expiredToken);
      const { data } = await api.put(
        `${process.env.REACT_APP_APIHOST}/configs/${expiredToken.key}`,
        {
          // config_key: 'expired_token',
          value: valueExpiredToken, // สมมติว่า enabled เป็น boolean ค่าที่จะส่ง
          description:
            'ระยะเวลาหมดอายุของ JWT payment Token (หน่วย: นาที) เช่น 60 = 1 ชั่วโมง',
        },
        {
          headers: {
            Authorization: token,
          },
        },
      );
      if (!data) {
        throw new Error('Network response was not ok');
      }
      console.log('Expired token updated successfully:', data);
      getExpiredToken();
      setOpenDialog(false);
    } catch (error) {
      console.error('Error updating expired token:', error);
    }
  };

  return (
    <>
      <Paper sx={{ padding: 4, maxWidth: 1200, margin: 'auto' }}>
        <Typography variant="h6" gutterBottom>
          ตั้งค่า
        </Typography>
        <TableContainer
          component={Paper}
          sx={{ maxWidth: 1200, mt: 5, mx: 'auto' }}
        >
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>
                  <Typography variant="body1">Popup Policy</Typography>
                </TableCell>
                <TableCell align="right">
                  <IOSSwitch checked={enabled} onChange={handleToggle} />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {/* <TableContainer
          component={Paper}
          sx={{ maxWidth: 1200, mt: 2, mx: 'auto' }}
        >
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>
                  <Typography variant="body1">Expired Token</Typography>
                </TableCell>
                <TableCell align="right">
                  <Button
                    variant="contained"
                    color="warning"
                    size="medium"
                    sx={{ color: '#fff' }}
                    onClick={() => setOpenDialog(true)}
                  >
                    Edit
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer> */}
      </Paper>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>แก้ไข Expired Token</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {expiredToken?.description || ' '}
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Expired Token (นาที)"
            type="number"
            fullWidth
            variant="outlined"
            size="small"
            defaultValue={expiredToken?.value || ''}
            onChange={(e) => setValueExpiredToken(e.target.value)}
            InputProps={{ inputProps: { min: 1 } }} // กำหนดค่า minimum เป็น 1
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="error"
            // sx={{ color: '#fff' }}
            onClick={() => setOpenDialog(false)}
          >
            ยกเลิก
          </Button>
          <Button
            variant="outlined"
            color="success"
            // sx={{ color: '#fff' }}
            onClick={() => {
              changeExpiredToken(expiredToken.value);
            }}
          >
            บันทึก
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Setting;
